module.exports = __webpack_public_path__ + "img/nav7.3ba5881f.svg";